// coachPrefs.ts — OPTIONAL touches on the free call (§5b vs Praktika, 2026-08-19).
// Bogdan's rule: "structure is there if you want it — the customer has the freedom to organise
// how they want." So: everything here defaults to OFF/empty, the call needs none of it, and the
// same asks work SPOKEN mid-call ("correct me more", "let's order food") — these controls are
// just the tappable shortcut. Device-only; travels as the mint's optional `context` field.
const INTENSITY_KEY = "oriora.speaking.intensity.v1";
const RECAP_KEY = "oriora.speaking.lastcall.v1";

export type Intensity = "soft" | "balanced" | "strict";

/** Shortcuts only — the scene field accepts anything the learner types. */
export const SCENE_SUGGESTIONS = [
  "Order at a café", "Job interview", "Ask for directions", "Small talk with a neighbour",
  "Doctor's appointment", "Check in at a hotel", "Tell me about your day", "Retell a story",
  "Phone call to book a table", "Bargain at a market",
];

export function getIntensity(): Intensity {
  try {
    const v = localStorage.getItem(INTENSITY_KEY);
    return v === "soft" || v === "strict" ? v : "balanced";
  } catch { return "balanced"; }
}
export function setIntensity(v: Intensity): void {
  try { localStorage.setItem(INTENSITY_KEY, v); } catch { /* current call still uses it */ }
}

// Coach continuity: a short local recap of the last call rides the next mint, so the coach can
// pick up where you left off. Built CLIENT-SIDE from the transcript tail; never stored server-side.
export function saveCallRecap(lines: { role: string; text: string }[], language: string, scene?: string): void {
  const tail = lines.slice(-8).map((l) => `${l.role === "you" ? "learner" : "coach"}: ${l.text}`).join(" · ");
  if (!tail) return;
  const recap = `[${language}${scene ? ` · ${scene}` : ""}] ${tail}`.slice(0, 500);
  try { localStorage.setItem(RECAP_KEY, recap); } catch { /* fine */ }
}
export function getCallRecap(): string {
  try { return localStorage.getItem(RECAP_KEY) ?? ""; } catch { return ""; }
}
